import { render } from "./rmThankYou.vue?vue&type=template&id=497a1958&scoped=true&lang=true"
import script from "./rmThankYou.vue?vue&type=script&lang=js"
export * from "./rmThankYou.vue?vue&type=script&lang=js"

import "./rmThankYou.vue?vue&type=style&index=0&id=497a1958&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497a1958"]])

export default __exports__